<!--案例参考-->
<template>
	<div class="case-reference">
		<div class="module-name">
			<div class="module-title">
				案例参考
			</div>
		</div>
        <v-iframe :src="'http://www.jssh.org.cn/flhdpt/alck/'" height="450"></v-iframe> 
	</div>
</template>
<script>
	export default {
		name: "caseReference",
		data() {
			return {};
		}
	};
</script>
<style lang="less" scoped>
	.case-reference {}
</style>